import {
  Injectable,
  Injector,
  ComponentFactoryResolver
} from '@angular/core';

import {DbModalOptions, DbModalConfig} from './modal-config';
import {DbModalRef} from './modal-ref';
import {DbModalStack} from './modal-stack';

/** A service for opening modal windows.
 *
 * Creating a modal is straightforward: create a component or a template and pass it as an argument to the `.open()` method.
 */
@Injectable({providedIn: 'root'})
export class DbModalService {
  constructor(
      private _moduleCFR: ComponentFactoryResolver, private _injector: Injector, private _modalStack: DbModalStack,
      private _config: DbModalConfig) {}

  /**
   * Opens a new modal window with the specified content and supplied options.
   *
   * Content can be provided as a `TemplateRef` or a component type. If you pass a component type as content,
   * then instances of those components can be injected with an instance of the `DbActiveModal` class. You can then
   * use `DbActiveModal` methods to close / dismiss modals from "inside" of your component.
   *
   * Also see the [`DbModalOptions`](#/components/modal/api#DbModalOptions) for the list of supported options.
   */
  open(content: any, options: DbModalOptions = {}): DbModalRef {
    const combinedOptions = {...this._config, ...options};
    return this._modalStack.open(this._moduleCFR, this._injector, content, combinedOptions);
  }

  /** Returns an observable that holds the active modal instances.*/
  get activeInstances() { return this._modalStack.activeInstances; }

  /** Dismisses all currently displayed modal windows with the supplied reason.*/
  dismissAll(reason?: any) { this._modalStack.dismissAll(reason); }

  /** Indicates if there are currently any open modal windows in the application.*/
  hasOpenModals(): boolean { return this._modalStack.hasOpenModals(); }
}
